import React from "react";
import {
  Avatar,
  Card,
  CardContent,
  IconButton,
  Typography,
  Box,
  useTheme,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useSelector } from "react-redux";
import UserProfileIcon from "../../../../assets/icons/UserProfile.png";
import toast from "react-hot-toast";

const CardInfoOfService = ({ healthSpecialist, typeService }) => {
  const theme = useTheme();
  const { status, firstName } = useSelector((state) => state.userReducer);
  const { membershipStatus } = useSelector((state) => state.membershipReducer);

  const handlePress = () => {
    try {
      if (status !== "active" || membershipStatus !== "active") {
        toast.error(
          `Tu cuenta no esta completa. \n ${status !== "active" ? "Completa tu información" : membershipStatus !== "active" && "Contrata una membresia."}`
        );
        return;
      }
      const formatNumber =
        healthSpecialist?.phoneNumber.replace(/\+/g, "") ?? "";
      const codedMessage = encodeURIComponent(
        `!Hola¡, soy ${firstName}, Quiero más información sobre su servicio en Radaria.`
      );
      // Web version of opening WhatsApp
      window.open(
        `https://wa.me/${formatNumber}?text=${codedMessage}`,
        "_blank"
      );
    } catch (error) {
      toast.error(
        "Intentalo más tarde. \n Su contacto no esta activo en este momento."
      );
    }
  };

  return (
    <Card
      sx={{
        width: 250,
        backgroundColor: theme.palette.background.paper,
        p: 1,
        borderRadius: 2,
        boxShadow: theme.shadows[1],
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "row",
          padding: theme.spacing(1),
          justifyContent: "space-between",
          alignItems: "center",
          gap: theme.spacing(2),
        }}
      >
        <Avatar
          src={healthSpecialist?.urlImg ?? UserProfileIcon}
          sx={{ width: 50, height: 50 }}
        />
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="subtitle1" fontWeight="medium">
            {healthSpecialist?.firstName ?? "---"}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {typeService ?? "Prestador de Servicio"}
          </Typography>
        </Box>
        <IconButton
          onClick={handlePress}
          sx={{
            color: theme.palette.success.main,
            "&:hover": {
              backgroundColor: theme.palette.success.light,
            },
          }}
        >
          <WhatsAppIcon fontSize="medium" />
        </IconButton>
      </CardContent>
    </Card>
  );
};

export default CardInfoOfService;
